import styled, { keyframes } from 'styled-components';
import {
  BigDot,
  EmptyDot,
  Lane,
  SmallDot,
  VariationSignWrapper,
} from '../../../ReportTimestemps/TimestampSigns/TimestampSigns.styles';

export const Wrapper = styled.div<{ isTopic: boolean }>`
  position: relative;
  width: 100%;
  height: ${({ isTopic }) => (isTopic ? '18px' : '20px')};
  border-radius: 4px;
  margin-right: 40px;
  ${({ theme }) => `
    background: ${theme.colors.neutral.primary[10]};
  `}
`;

export const Tooltip = styled.div`
  visibility: hidden;
  width: auto;
  background-color: #808080;
  min-width: 50px;
  color: white;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;

  ::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #808080 transparent transparent transparent;
  }
`;

const growWidth = (width: number) => keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: ${width}%;
  }
`;

export const ValueBar = styled.div<{ color: string; width: number }>`
  position: relative;
  height: 100%;
  animation: ${({ width }) => growWidth(width)} 1s ease-out forwards;
  background: ${({ color }) => color};
  border-radius: 4px;
`;

export const BlueDot = styled(SmallDot)<{ value: number }>`
  position: absolute;
  left: ${({ value }) => value}%;
  top: 50%;
  transform: translate(-50%, -50%);
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const HistoricalLane = styled(Lane)<{ value: number }>`
  position: absolute;
  left: ${({ value }) => value}%;
  top: 50%;
  transform: translate(-50%, -50%);
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const YellowDot = styled(BigDot)<{ value: number }>`
  position: absolute;
  left: ${({ value }) => value}%;
  top: 50%;
  transform: translate(-50%, -50%);
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const EmptyManagerDot = styled(EmptyDot)<{ value: number }>`
  position: absolute;
  left: ${({ value }) => value}%;
  top: 50%;
  transform: translate(-50%, -50%);
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const VariationSign = styled(VariationSignWrapper)`
  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
